import { render, staticRenderFns } from "./AuthSwitch.vue?vue&type=template&id=edf6eab6&"
import script from "./AuthSwitch.vue?vue&type=script&lang=js&"
export * from "./AuthSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports